import React, { useEffect } from 'react';
import TStore from '../../../../../types/store';
import { bindActionCreators } from 'redux';
import { actions } from '../../../../../store/ducks/reservation-form-slice';
import { connect } from 'react-redux';
import { SelectFieldProps } from '../../../../../types/reservation-form';
import { useField } from 'formik';
import { TagSelect } from '@hilbi/web-common/components/e-visits/select/select';

type TagSelectProps = SelectFieldProps &
  ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps>;

const ReservationTagSelect: React.FunctionComponent<TagSelectProps> = ({
  name,
  tagOptions,
  setSelectedTag,
  disabled,
}) => {
  const [_, meta, helpers] = useField(name);
  const { value, error } = meta;
  const { setValue } = helpers;
  useEffect(() => {
    setSelectedTag && setSelectedTag(value);
  }, [value]);

  return (
    <TagSelect
      name={name}
      disabled={!!disabled}
      tagOptions={tagOptions}
      value={value}
      error={error}
      setValue={setValue}
    />
  );
};

const mapStateToProps = (state: TStore) => ({
  tagOptions: state.reservationForm.tagOptions,
});

const mapDispatchToProps = (dispatch: any) => {
  return bindActionCreators(
    {
      setSelectedTag: actions.setSelectedTag,
    },
    dispatch,
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(React.memo(ReservationTagSelect));
